import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollAPDExporter  {
    _originalTypeClassName = "zERP.BO.PayrollAPDExporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollAPDExporter.translate = translateService;
}
this.PayrollAPDExporterKey = null;
this._key = this.PayrollAPDExporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _PayrollAPDExporterKey:any;
get PayrollAPDExporterKey(): any {
    return this._PayrollAPDExporterKey;
  }
set PayrollAPDExporterKey(value: any) {
    this._PayrollAPDExporterKey = value;
    this._key = value;
  }

static GetCollectionVariables(apd: any,ptype: any): any{let empty = [];
let vars = new window['Map']();
let groupSalaryTypechildren = [];
groupSalaryTypechildren?.add({
Name: "salarytype",Description: "Τύπος Αποδοχής",}
);
groupSalaryTypechildren?.add({
Name: "totalsalary",Description: "Αποδοχές",Type: Domain.ExcelExporterVariableType.Currency,}
);
groupSalaryTypechildren?.add({
Name: "totalcontributions",Description: "Εισφορές",Type: Domain.ExcelExporterVariableType.Currency,}
);
vars.set({
Name: "SALARY_TYPESGROUPED",Description: "Ομαδοποίηση ανα Τύπο Αποδοχής",IsCollection: true,Children: groupSalaryTypechildren,}
, Joove.Common.cast(Domain.PayrollAPDExporter.GroupSalaryTypes(apd?.PayrollCalculations, ptype), "System.Collections.List"));
return vars;
}
static GetVariables(typeAPD: any): any{let vars = new window['Map']();
vars.set("PRONOUNCEMENT_TYPE", {
Value: typeAPD?.PayrollIntegration?.APDHeader?.PronouncementType,Description: "Τύπος Δήλωσης",}
);
vars.set("LOCAL_SUBMISSION_DIRECTION", {
Value: typeAPD?.PayrollIntegration?.APDHeader?.LocalSubmissionDirection,Description: "Τοπική Διεύθυνση Υποβολής ",}
);
vars.set("COMPANY_NAME", {
Value: typeAPD?.PayrollIntegration?.APDHeader?.CompanyLastName,Description: "Επωνυμία Εργοδότη",}
);
vars.set("AME", {
Value: typeAPD?.PayrollIntegration?.APDHeader?.AME,Description: "ΑΜΕ",}
);
vars.set("AFM", {
Value: typeAPD?.PayrollIntegration?.APDHeader?.AFM,Description: "ΑΦΜ",}
);
vars.set("ADDRESS", {
Value: Domain.Address.GetFullAddress(typeAPD?.PayrollIntegration?.APDHeader?.Address),Description: "Διεύθυνση",}
);
vars.set("REFERENCE_MONTH", {
Value: typeAPD?.PayrollIntegration?.APDHeader?.ReferenceMonth,Description: "Μήνας Από",}
);
vars.set("REFERENCE_YEAR", {
Value: typeAPD?.PayrollIntegration?.APDHeader?.ReferenceYear,Description: "Έτος Από",}
);
vars.set("TOTAL_INSURANCE_DAYS", {
DecimalValue: typeAPD?.PayrollIntegration?.APDHeader?.TotalInsuranceDays,Description: "Σύνολο Ημερών Ασφάλισης",}
);
vars.set("TOTAL_SALARY", {
DecimalValue: typeAPD?.PayrollIntegration?.APDHeader?.TotalSalary,Description: "Σύνολο Αποδοχών",}
);
vars.set("TOTAL_CONTRIBUTIONS_PAY", {
DecimalValue: typeAPD?.PayrollIntegration?.APDHeader?.TotalContributionsPayable,Description: "Σύνολο Καταβλητέων Εισφορών",}
);
vars.set("TOTAL_INSURED", {
DecimalValue: typeAPD?.PayrollIntegration?.APDInsured?.length,Description: "Σύνολο Ασφαλισμένων",}
);
return vars;
}
static GroupSalaryTypes(prcalculationslst: any,ptype: any): any{let selectedPayrolls = [];
let dtos = [];
let contributionsDictionary = new window['Map']();
for (let _icalculation = 0; _icalculation < (prcalculationslst == null ? 0 : prcalculationslst.length); _icalculation++) {let calculation = prcalculationslst[_icalculation];if (ptype == Domain.SIC_PackageType.PrivateSector) {for (let _iempPay = 0; _iempPay < (calculation?.Employees?.linq?.orderBy((e) => e?.Employee?.SocialSecurityNumber)?.toArray() == null ? 0 : calculation?.Employees?.linq?.orderBy((e) => e?.Employee?.SocialSecurityNumber)?.toArray().length); _iempPay++) {let empPay = calculation?.Employees?.linq?.orderBy((e) => e?.Employee?.SocialSecurityNumber)?.toArray()[_iempPay];for (let _idet = 0; _idet < (empPay?.Contributions == null ? 0 : empPay?.Contributions.length); _idet++) {let det = empPay?.Contributions[_idet];if (det?.Rule?.IsActive && det?.Rule?.SICPackageType == Domain.SIC_PackageType.PrivateSector) {if (!(selectedPayrolls?.linq?.contains(empPay))) {selectedPayrolls?.add(empPay);}}}}}if (ptype == Domain.SIC_PackageType.PublicSector) {for (let _iempPay = 0; _iempPay < (calculation?.Employees?.linq?.orderBy((e) => e?.Employee?.SocialSecurityNumber)?.toArray() == null ? 0 : calculation?.Employees?.linq?.orderBy((e) => e?.Employee?.SocialSecurityNumber)?.toArray().length); _iempPay++) {let empPay = calculation?.Employees?.linq?.orderBy((e) => e?.Employee?.SocialSecurityNumber)?.toArray()[_iempPay];for (let _idet = 0; _idet < (empPay?.Contributions == null ? 0 : empPay?.Contributions.length); _idet++) {let det = empPay?.Contributions[_idet];if (det?.Rule?.IsActive && det?.Rule?.SICPackageType == Domain.SIC_PackageType.PublicSector) {if (!(selectedPayrolls?.linq?.contains(empPay))) {selectedPayrolls?.add(empPay);}}}}}if (ptype == Domain.SIC_PackageType.TEKA) {for (let _iempPay = 0; _iempPay < (calculation?.Employees?.linq?.orderBy((e) => e?.Employee?.SocialSecurityNumber)?.toArray() == null ? 0 : calculation?.Employees?.linq?.orderBy((e) => e?.Employee?.SocialSecurityNumber)?.toArray().length); _iempPay++) {let empPay = calculation?.Employees?.linq?.orderBy((e) => e?.Employee?.SocialSecurityNumber)?.toArray()[_iempPay];for (let _idet = 0; _idet < (empPay?.Contributions == null ? 0 : empPay?.Contributions.length); _idet++) {let det = empPay?.Contributions[_idet];if (det?.Rule?.IsActive && det?.Rule?.SICPackageType == Domain.SIC_PackageType.TEKA) {if (!(selectedPayrolls?.linq?.contains(empPay))) {selectedPayrolls?.add(empPay);}}}}}}
for (let _ipayroll = 0; _ipayroll < (selectedPayrolls == null ? 0 : selectedPayrolls.length); _ipayroll++) {let payroll = selectedPayrolls[_ipayroll];for (let _iconDetail = 0; _iconDetail < (payroll?.Contributions == null ? 0 : payroll?.Contributions.length); _iconDetail++) {let conDetail = payroll?.Contributions[_iconDetail];let tmpDetails = [];if (!(contributionsDictionary.has(conDetail?.SalaryType?.CodeAndName))) {tmpDetails?.add(conDetail);contributionsDictionary.set(conDetail?.SalaryType?.CodeAndName, tmpDetails);continue;}tmpDetails = contributionsDictionary.get(conDetail?.SalaryType?.CodeAndName);tmpDetails?.add(conDetail);contributionsDictionary.set(conDetail?.SalaryType?.CodeAndName, tmpDetails);}}
for (let _ikey = 0; _ikey < (Array['from'](contributionsDictionary.keys()) == null ? 0 : Array['from'](contributionsDictionary.keys()).length); _ikey++) {let key = Array['from'](contributionsDictionary.keys())[_ikey];let newDTO = new Domain.APDSalaryTypeGroupingDTO();let values = contributionsDictionary.get(key);newDTO.Name = key;newDTO.TotalSalary = values?.linq?.sum((l) => l?.EmployeeAmount);newDTO.TotalContributions = values?.linq?.sum((l) => l?.EmployeeContribution);newDTO.TotalContributions = values?.linq?.sum((l) => l?.EmployerContribution);dtos?.add(newDTO);}
return dtos;
}
static ResolveCollectionItem(collectionName: any,varName: any,item: any): any{let resp;
resp.Value = "";
if (collectionName == "SALARY_TYPESGROUPED") {let salarytype = Joove.Common.cast(item, "Domain.APDSalaryTypeGroupingDTO");switch (varName?.toLowerCase()) {case "salarytype":
{
resp.Value = salarytype?.Name;return resp;}
case "totalsalary":
{
resp.Value = salarytype?.TotalSalary;resp.VType = Domain.ExcelExporterVariableType.Currency;return resp;}
case "totalcontributions":
{
resp.Value = salarytype?.TotalContributions;resp.VType = Domain.ExcelExporterVariableType.Currency;return resp;}
}}
return resp;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollAPDExporterKey == null || $this.PayrollAPDExporterKey == 0;
            }


}